import { useState, useEffect } from 'react';
import { Route } from '../types/route.types';
import { routeService } from '../services/routeService';

interface UseRoutesResult {
  routes: Route[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Hook pour récupérer et gérer les routes
 */
export const useRoutes = (activity?: string): UseRoutesResult => {
  const [routes, setRoutes] = useState<Route[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchRoutes = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await routeService.fetchRoutes(activity);
      setRoutes(data);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoutes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activity]);

  return {
    routes,
    loading,
    error,
    refetch: fetchRoutes,
  };
};
